import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // Check if user is authenticated
    if (!this.authService.isAuthenticated()) {
      // Store redirect URL for after login
      sessionStorage.setItem('redirectUrl', state.url);
      this.router.navigate(['/login']);
      return false;
    }

    // Check if user needs to change password
    if (this.authService.requiresPasswordChange() && state.url !== '/wachtwoord-wijzigen') {
      this.router.navigate(['/wachtwoord-wijzigen']);
      return false;
    }

    // Check if user needs to select company (but don't redirect if already on that page)
    if (this.authService.needsCompanySelection() && state.url !== '/bedrijf-selecteren') {
      this.router.navigate(['/bedrijf-selecteren']);
      return false;
    }

    return true;
  }
}
